import { render, staticRenderFns } from "./SaleTaxRule.vue?vue&type=template&id=b28c0542&"
import script from "./SaleTaxRule.vue?vue&type=script&lang=js&"
export * from "./SaleTaxRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports